import { useState } from "react";
import { Sidebar } from "../SideBar";
import Dashboard from "../ui/Dashboard";

export default function HrLayout({ children }) {
    const [open, setOpen] = useState(false);

    return (
        <div className="flex min-h-screen bg-background/50">
            <Sidebar open={open} setOpen={setOpen} />

            <div className="flex-1 bg-[#FFFF]">
                <Dashboard setOpen={setOpen} />
                <div className="pt-[56px] rs:pt-[72px] relative z-1">{children}</div>
            </div>
        </div>
    )
}